module.exports = __webpack_public_path__ + "img/footer_payment_proof.a26d752a.png";